import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import CommonToast from 'components/commom/CommonToast';
import ReusableButton from 'components/commom/Button';
import CommonModal from 'components/commom/Modal';
import LabelWithInput from 'components/commom/LabelWithInput';
import AddIcon from 'assets/images/Dashboard/add-dashboard.svg';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ClearTokenRedirectLogin } from 'utils/general';
import { getDoctorDrop } from 'store/getDoctorListDropdown/getDoctorListDropdownAction';
import CreateLocation from './CreateLoction';
import { getLocationCallAPI } from 'store/Enterprise/enterprise/getLocation/action';
import { deleteLocationCallAPI } from 'store/EnterpriseAdmin/Location/deleteLocation/action';

const EnterpriseLocation = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    search: '',
  });
  const [viewData, setViewData] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isModalActive, setIsModalActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [countryData, setCountryData] = useState({});
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const locationList = useSelector(
    (state) => state?.getLocationReducer?.users?.data
  );
  const locationLoader = useSelector(
    (state) => state?.getLocationReducer?.loading
  );
  const locationDeleteLoader = useSelector(
    (state) => state?.deleteLocationReducer?.loading
  );
  const enterpriseData = useSelector(
    (state) => state?.getEnterpriseProfileReducer?.users?.data
  );

  useEffect(() => {
    getCountryData();
    setLoading(true);
  }, []);

  const getData = () => {
    dispatch(
      getLocationCallAPI(
        enterpriseData?.enterprise?.enterprise_id,
        {
          run: true,
          handleFunction: () => {
            setLoading(false);
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            showToast(res?.message, 'error');
          },
        },
        formData?.search
      )
    );
  };

  const getCountryData = () => {
    dispatch(
      getDoctorDrop({
        run: true,
        handleFunction: (res) => {
          setCountryData(res?.data);
          getData();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAction = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    getData();
  };

  const handleApply = () => {
    getData();
  };

  const handleDelete = () => {
    const body = {
      id: viewData?.id,
      enterpriseId: enterpriseData?.enterprise?.enterprise_id,
    };
    dispatch(
      deleteLocationCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          setIsModalActive(false);
          showToast(res?.message, 'success');
          getData();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="d-flex justify-between">
            <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
              <FormattedMessage id="Locations" />
            </h2>
          </div>
          {!loading && (
            <Row
              className="mt-3"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Col md={2} className="mt-4">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  Search:
                </div>
                <div>
                  <LabelWithInput
                    // label=""
                    placeholder="Search"
                    name="search"
                    type="text"
                    marginLabelTop={'0'}
                    marginTop={'0'}
                    bgColor="white"
                    placeholdercolor="#000000"
                    value={formData?.search}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
              </Col>
              <Col md={2} className="mt-5">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#375241] h-[44px] flex items-center justify-center text-white cursor-pointer"
                  onClick={() => {
                    handleApply();
                  }}
                >
                  Apply
                </div>
              </Col>
              <Col md={8} className="mt-5 justify-content-end d-flex">
                <div
                  className="w-full md:max-w-[30%] lg:max-w-[20%] fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#874529] h-[44px] flex items-center justify-center text-white cursor-pointer gap-[10px]"
                  onClick={() => {
                    setDrawerOpen(true);
                    setViewData({});
                  }}
                >
                  <Image src={AddIcon} alt={'icon'} />
                  <div>Create</div>
                </div>
              </Col>
            </Row>
          )}
          {locationLoader || loading ? (
            <Loader marginTop={'20vh'} />
          ) : (
            <div className="mt-[30px]">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Address
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Country
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    City
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    State
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Zip Code
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Action
                  </p>
                </Col>
              </Row>
              <Row className="bc-FFFFFF m-0 p-0">
                {locationList && locationList?.length > 0 ? (
                  locationList?.map((item, index) => (
                    <Row
                      className="m-0 p-0 flex items-center listAppointment"
                      key={index}
                    >
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                          {item?.address}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {`${item?.country}`}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {`${item?.city}`}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {`${item?.state}`}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {`${item?.postal_code}`}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <MoreVertOutlinedIcon
                          aria-describedby={id}
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => handleAction(e, item)}
                        />
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div className="flex flex-col justify-center items-center py-[50px]">
                    <Image
                      src={EmptyScreen}
                      alt="icon"
                      width={'301px'}
                      height={'224px'}
                    />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                      Nothing here yet
                    </div>
                  </div>
                )}
              </Row>
            </div>
          )}
        </Col>
      </Row>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box>
          <Box
            onClick={() => {
              setDrawerOpen(true);
              handleClose();
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 3,
              py: 1,
              cursor: 'pointer',
              borderBottom: '1px solid #eee',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <EditIcon fontSize="small" />
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                fontFamily: 'Outfit, sans-serif',
              }}
            >
              Edit
            </Typography>
          </Box>
          <Box
            onClick={() => {
              setIsModalActive(true);
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 3,
              py: 1,
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <DeleteIcon fontSize="small" />
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                fontFamily: 'Outfit, sans-serif',
              }}
            >
              Delete
            </Typography>
          </Box>
        </Box>
      </Popover>

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={isModalActive}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      setIsModalActive(false);
                      handleClose();
                    }}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      handleDelete();
                      handleClose();
                    }}
                    loading={locationDeleteLoader}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />

      <CreateLocation
        open={drawerOpen}
        onClose={handleDrawerClose}
        countryData={countryData}
        editData={viewData}
      />
    </div>
  );
};

export default EnterpriseLocation;
